import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import WaiterNavbar from "../components/WaiterNavbar";
import { ILoginInfo } from "../models/ILoginInfo";
import { getUserToken } from "../utils/Util";
import { applyRestaurantFromUrl } from "../utils/activeRestaurant";

function Control(props: { item: JSX.Element }) {
  const location = useLocation();
  const token = getUserToken();
  // /dashboard?restaurant=<id> ile açılan sekme o restorana geçer (yeni sekmede aç).
  if (token) applyRestaurantFromUrl();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // LiveChat-only hesaplar: navbar yok, sadece /liveChat ekranını kullanabilirler.
  if ((token as ILoginInfo).isLiveChatOnly) {
    if (location.pathname !== "/liveChat") {
      return <Navigate to="/liveChat" replace />;
    }
    return props.item;
  }

  // Kurye hesapları: navbar yok, başka hiçbir ekranı göremezler, sadece /kuryePaneli.
  if ((token as ILoginInfo).isDriverOnly) {
    if (location.pathname !== "/kuryePaneli") {
      return <Navigate to="/kuryePaneli" replace />;
    }
    return props.item;
  }

  // Garson hesapları: sadece garson menüsü ve /garson (Salon Siparişi) ekranı.
  if ((token as ILoginInfo).isWaiterOnly) {
    if (location.pathname !== "/garson") {
      return <Navigate to="/garson" replace />;
    }
    return (
      <>
        <WaiterNavbar />
        {props.item}
      </>
    );
  }

  const userObj: ILoginInfo = {
    token: "",
    expiration: "",
    userId: "",
    secretKey: "",
    restourantId: "",
  };

  return (
    <>
      <Navbar user={userObj}></Navbar>
      {props.item}
    </>
  );
}

export default Control;
